<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KAmbax/tc-custom/9780230102316.jpg?1738254579757" alt="This image is the cover for the book Paris Under Water"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Paris Under Water
      </h1>
      <p class="bookDescription body article font2">
        <p>In the winter of 1910, the river that brought life to Paris quickly became a force of destruction.  Torrential rainfall saturated the soil, and faulty engineering created a perfect storm of conditions that soon drowned Parisian streets, homes, businesses, and museums. The city seemed to have lost its battle with the elements. Given the Parisians' history of deep-seated social, religious, and political strife, it was questionable whether they could collaborate to confront the crisis. Yet while the sewers, Métro, and electricity failed around them, Parisians of all backgrounds rallied to save the city and one another. Improvising techniques to keep Paris functioning and braving the dangers of collapsing infrastructure and looters, leaders and residents alike answered the call to action. This newfound ability to work together proved a crucial rehearsal for an even graver crisis four years later, when France was plunged into World War I. On the occasion of the hundredth anniversary of the flood, Jeffrey H. Jackson captures here for the first time the drama and ultimate victory of man over nature.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey H. Jackson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c34006a0